var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-cellrenderer-progressbar"},[_c('div',[_c('div',{style:(`width: ${_vm.params.value.value ? _vm.params.value.value : 0 }%; background-color: ${_vm.params.value.color}`)})]),_c('p',{staticClass:"ml-2 mt-0"},[_vm._v(_vm._s(_vm.params.value.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }